import type { Order } from "@src/api";

export const filterOrders = (
  orders: Order[],
  filterStatus: string | null,
  currentUserId: string,
  sectionFilters: string[] = [],
  storeFilters: string[] = [],
): Order[] => {
  return orders.filter((order) => {
    // Фильтр по статусу
    let matchesStatus = true;
    if (filterStatus) {
      switch (filterStatus) {
        case "new":
          matchesStatus = ["request", "reserving"].includes(order.status);
          break;
        case "my":
          matchesStatus = order.created_by === currentUserId || order.executed_by === currentUserId;
          break;
        case "in_progress":
          matchesStatus = order.status === "picking";
          break;
        case "done":
          matchesStatus = ["complete", "canceled", "failed", "expired"].includes(order.status);
          break;
        default:
          matchesStatus = !["complete", "canceled", "failed", "expired"].includes(order.status);
      }
    } else {
      // Если нет активного статусного фильтра, показываем все незавершенные
      matchesStatus = !["complete", "canceled", "failed", "expired"].includes(order.status);
    }

    if (!matchesStatus) {
      return false;
    }

    // Фильтр по секциям
    if (sectionFilters.length > 0) {
      if (!order.place_section) {
        return false;
      }
      // Приводим к нижнему регистру для сравнения (place_section: "woman" | "man" | "kids")
      const orderSection = order.place_section.toLowerCase();
      const matchesSection = sectionFilters.some((filterSection) => filterSection.toLowerCase() === orderSection);
      if (!matchesSection) {
        return false;
      }
    }

    // Фильтр по складам
    if (storeFilters.length > 0) {
      if (!order.place_from_type) {
        return false;
      }
      // Приводим к нижнему регистру для сравнения
      const orderStore = order.place_from_type.toLowerCase();
      const matchesStore = storeFilters.some((filterStore) => filterStore.toLowerCase() === orderStore);
      if (!matchesStore) {
        return false;
      }
    }

    return true;
  });
};
